angular.module('dealerware.web.data').factory('DealerwareEmployeeCollection', function ($http,Collection,DealerwareEmployeeModel,$q,DataUtils) {
    'use strict';

    var baseEndpoint = '/locations/:location_id/users';

    var collection = new Collection({
        baseEndpoint: baseEndpoint,
        actionOverrides: undefined,
        customActions: {
            solr_search: {
                method: 'GET',
                endpoint: '/locations/:location_id/users/search',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true,
                headers: false
            },
            solr_search_with_filters: {
                method: 'GET',
                endpoint: baseEndpoint,
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true
            }
        },
        params: {
            include_user_profile: true,
            include_roles: true
        },
        responseTransforms: new function() {
            this.solr_search = mapSolrSearchResults;
            this.solr_search_with_filters = mapSolrSearchResults;
        },
        responseFormatter: undefined,
        associationMapper:undefined,
        rootNode: 'user',
        rootNodeResponse: undefined,
        rootNodeRequest: undefined,
        model: 'DealerwareEmployeeModel'
    });

    function mapSolrSearchResults (args, data) {

        data.forEach( function (employee) {
            employee.data.user_profile_attributes = angular.extend(
                { },
                employee.data.user_profile,
                { phone_number: DataUtils.getInstance().normalizePhoneNumber(
                    employee.data.user_profile.phone_number
                )}
            )

            delete employee.data.user_profile;
        });
    }

    jQuery.extend(collection.prototype, {});

    return collection;
});
